
import { Component, Mixins, Ref, Watch } from "vue-property-decorator";
import TakipInfo from "@/components/infos/TakipInfo.vue";
import { TakipEntity } from "@/entity/TakipEntity";
import AlacakList from "@/components/lists/AlacakList.vue";
import BorcluCardList from "@/components/lists/BorcluCardList.vue";
import AlacakliCardInfo from "@/components/infos/AlacakliCardInfo.vue";
import NotList from "@/components/lists/NotList.vue";
import DokumanList from "@/components/lists/DokumanList.vue";
import DilekceForm from "@/components/forms/DilekceForm.vue";
import FormDialog from "@/components/dialogs/FormDialog.vue";
import IsList from "@/components/lists/IsList.vue";
import { TakipDurumu } from "@/enum/TakipDurumu";
import KapakHesabi from "@/components/infos/KapakHesabi.vue";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import {ProgramPaths} from "@/enum/ProgramPaths";

interface FaizDataType {
  hesaplanabilir: boolean;
  data: TakipEntity | { message: string };
}

@Component({
  components: {
    KapakHesabi,
    IsList,
    FormDialog,
    DilekceForm,
    DokumanList,
    NotList,
    AlacakliCardInfo,
    BorcluCardList,
    AlacakList,
    TakipInfo,
  }
})
export default class TakipDetayView extends Mixins(ObjectInputMixin) {
  @Ref('isList') readonly isListesi!: IsList;
  @Ref('notList') readonly notList!: NotList;

  fab = false;
  hover = false;
  show = false;
  show1 = false;
  show2 = false;
  TakipDurumu = TakipDurumu;
  ProgramPaths = ProgramPaths;
  takipFiles:any = []

  @Watch('show1')
  openFiles(){
    if (this.show1){
      this.$http.get('/api/v1/takip/' + this.$route.params.id + '/files').then((response) => {
        this.takipFiles = response.data.files;
      })

    }
  }
  get takip(): TakipEntity {
    return this.$store.getters['takipDetay/takip'];
  }

  get faizData(): FaizDataType {
    const data = this.$store.getters['takipDetay/faizData'];
    console.log('TakipDetayView - faizData getter çağrıldı:', data);
    return data;
  }

  get faizLoading(): boolean {
    return this.$store.getters['takipDetay/faizLoading'];
  }

  get takipAlacaklar(): { isGetted: boolean, data: any[] } {
    return {
      isGetted: true,
      data: this.takip?.alacaklar || []
    };
  }

  get alacaklarLoading(): boolean {
    // TakipDetay store'da ayrı loading state yok, faizLoading kullanılabilir
    return false;
  }

  get isListesiShouldReload() {
    return this.$store.state.takipDetay.isListesiShouldReload;
  }
  birSonrakiTakip(){
    this.$http.get('/api/v1/takip/'+this.$route.params.id + '/next').then((response:any) => {
      if (response.data.takip_durumu == this.TakipDurumu.acilmamis) {
        this.$router.push(`/icrapro/takip-ekle/${response.data.id}`);
      }else{
        this.$router.push(`/icrapro/takip/${response.data.id}`);
      }
    })
  }

  birOncekiTakip(){
    this.$http.get('/api/v1/takip/'+this.$route.params.id + '/back').then((response:any) => {
      if (response.data.takip_durumu == this.TakipDurumu.acilmamis) {
        this.$router.push(`/icrapro/takip-ekle/${response.data.id}`);
      }else{
        this.$router.push(`/icrapro/takip/${response.data.id}`);
      }
    })
  }
  /** Yeni ID geldiğinde önce cache temizle, sonra yükle */
  @Watch('$route.params.id', { immediate: true })
  async onIdChange(newId: string, oldId: string) {
    if (!newId) return;
    // Sadece takip verisi yüklensin, iş listesi ayrıca çağrılmasın
    await this.$store.dispatch('takipDetay/loadTakip', newId);
  }

  @Watch('isListesiShouldReload')
  onIsListesiShouldReload(val: boolean) {
    if (val) {
      this.load('isListesi');
      this.$store.dispatch('takipDetay/resetIsListesiReload');
    }
  }

  async onAddAlacak(payload: any) {
    // Payload varsa (ekleme işlemi), store'a ekle
    if (payload) {
      await this.$store.dispatch('takipDetay/addAlacak', {
        takipId: this.takip.id,
        alacak: payload
      })
    }

    // SIRA ÖNEMLİ: Önce alacaklar, sonra faiz
    // 1. Önce alacakları güncelle ve liste görünsün
    await this.load('alacaklar');

    // 2. Sonra faiz verilerini yenile
    await this.load('faiz');
  }

  async onDeleteAlacak(id: number) {
    await this.$store.dispatch('takipDetay/deleteAlacaklar', {
      takipId: this.takip.id,
      id
    })

    // SIRA ÖNEMLİ: Önce alacaklar, sonra faiz
    await this.load('alacaklar');
    await this.load('faiz');
  }

  async onUpdateAlacak(id: number) {
    await this.$store.dispatch('takipDetay/updateAlacak', {
      takipId: this.takip.id,
      id
    })

    // SIRA ÖNEMLİ: Önce alacaklar, sonra faiz
    await this.load('alacaklar');
    await this.load('faiz');
  }

  async onAddAlacaklilar(payload: any) {
    await this.$store.dispatch('takipDetay/addAlacaklilar', {
      takipId: this.takip.id,
      alacakli: payload
    })
    await this.$store.dispatch('takipDetay/loadAlacaklilar', this.takip.id);
  }
  async onDeleteAlacaklilar(id: number) {
    await this.$store.dispatch('takipDetay/deleteAlacaklilar', {
      takipId: this.takip.id,
      id
    })
    await this.$store.dispatch('takipDetay/loadAlacaklilar', this.takip.id);
  }


  async onAddBorclu(payload: any) {
    await this.$store.dispatch('takipDetay/addBorclular', {
      takipId: this.takip.id,
      borclu: payload
    })
    await this.$store.dispatch('takipDetay/loadBorclular', this.takip.id);
  }

  async onAddIsListesi(payload: any) {
    await this.$store.dispatch('takipDetay/updateIsListesi', {
      takipId: this.takip.id,
      is: payload
    });
    // Sadece iş listesi güncellensin
    await this.$store.dispatch('takipDetay/loadIsListesi', this.takip.id);
  }

  async onDeleteIsListesi(id: number) {
    await this.$store.dispatch('takipDetay/deleteIsListesi', {
      takipId: this.takip.id,
      id
    });
    // Sadece iş listesi güncellensin
    await this.$store.dispatch('takipDetay/loadIsListesi', this.takip.id);
  }

  async onUpdateIsListesi(payload: any) {
    await this.$store.dispatch('takipDetay/updateIsListesi', {
      takipId: this.takip.id,
      is: payload
    })
    await this.$store.dispatch('takipDetay/loadBorclular', this.takip.id);
  }

  async onAddNot(payload: any) {
    await this.$store.dispatch('takipDetay/addNot', {
      takipId: this.takip.id,
      not: payload
    })
    await this.$store.dispatch('takipDetay/loadNotlar', this.takip.id);
    await this.$store.dispatch('takipDetay/triggerIsListesiReload');
  }
  async onDeleteNot(id: number) {
    await this.$store.dispatch('takipDetay/deleteNot', {
      takipId: this.takip.id,
      id
    })
  }

  async onUpdateNot(payload: any) {
    await this.$store.dispatch('takipDetay/updateNot', {
      takipId: this.takip.id,
      not: payload
    })
  }

  async onNotIsAdded() {
    // Not üzerinden iş eklendiğinde sadece iş listesi güncellensin
    if (this.isListesi) {
      await this.$store.dispatch('takipDetay/loadIsListesi', this.$route.params.id);
      this.isListesi.load();
      console.log('TakipDetayView: Not üzerinden iş eklendi, iş listesi güncellendi');
    }
  }

  async load(part?: 'borclular'|'alacaklilar'|'alacaklar'|'isListesi'|'notlar'|'faiz') {
    const id = this.$route.params.id as string;
    if (!id) return;

    try {
      switch (part) {
        case 'borclular':
          await this.$store.dispatch('takipDetay/loadBorclular', id);
          return;

        case 'alacaklilar':
          await this.$store.dispatch('takipDetay/loadAlacaklilar', id);
          return;

        case 'alacaklar':
          await this.$store.dispatch('takipDetay/loadAlacaklar', id);
          return;

        case 'isListesi':
          await this.$store.dispatch('takipDetay/loadIsListesi', id);
          return;

        case 'notlar':
          await this.$store.dispatch('takipDetay/loadNotlar', id);
          return;

        case 'faiz':
          await this.$store.dispatch('takipDetay/loadFaizData', id);
          return;  // faiz kendi içinde loading prop'u güncelliyor

        default:
          // Sadece ilk yüklemede tüm verileri çek
          await this.$store.dispatch('takipDetay/loadTakip', id);
      }
    } catch (err) {
      console.error('load error:', err);
    }
  }

  takipAtlaWrapper(event: Event, isForward: boolean) {
    event.stopPropagation();
    try {
      this.$toast.info(isForward ? "Önceki takibe geçiliyor..." : "Sonraki takibe geçiliyor...");

      const filteredTakip = localStorage.getItem('filteredTakip');
      if (!filteredTakip) {
        if (this.$route.params.id) {
          const currentId = parseInt(this.$route.params.id, 10);
          if (!isNaN(currentId)) {
            const nextId = isForward ? currentId + 1 : currentId - 1;
            this.$toast.info(`Takip listesi bulunamadı. ${isForward ? 'Önceki' : 'Sonraki'} takip ID'si (${nextId}) deneniyor...`);
            this.$router.push(`/icrapro/takip-detay/${nextId}`);
            return;
          }
        }
        this.$toast.warning('Takip listesi bulunamadı. Lütfen önce takip listesini görüntüleyin.');
        return;
      }
      this.$store.dispatch('takipDetay/takipAtlaWrapper', isForward);
    } catch (error) {
      this.$toast.error('Takip atlama işlemi sırasında bir hata oluştu');
    }
  }

  async created() {
    let activeProcess = {id: this.$route.params.id, key: 'takip-duzenle'}
    this.$store.commit('setActiveProcess', activeProcess);
  }
  isAuthorized(keySuffix: string) {
    let ap = this.$store.state.activeProcesses;
    let authKey = null;
    if (keySuffix[0] !== '-')
      keySuffix = '-' + keySuffix;
    if (ap.filter((item: any) => item.key === "takip-ac").length > 0)
      authKey = "takip-ac";
    else if (ap.filter((item: any) => item.key === "takip-duzenle").length > 0)
      authKey = keySuffix;
    if (!authKey)
      return false;
    return this.$helper.isAuthorized(authKey)
  }
}
